import { dashboardStatsSchema } from "@redotech/redo-dispute-db-schema/dispute-analytics";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDisputeDashboardStats = {
  name: "getDisputeDashboardStats" as const,
  input: z.object({
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
  }),
  output: dashboardStatsSchema,
};
